import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'phosphor-react';

export const SaveToast: React.FC<{ visible: boolean }> = ({ visible }) => (
  <AnimatePresence>
    {visible && (
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 8 }}
        transition={{ duration: 0.2 }}
        className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-2 rounded-full bg-foreground text-background text-sm font-sans shadow-lg pointer-events-none"
      >
        <CheckCircle size={16} weight="fill" />
        Guardado
      </motion.div>
    )}
  </AnimatePresence>
);
